//=================================================
// Global bundle
//=================================================
import '@hotwired/turbo-rails';
// Variable for conditionally firing GA events
window.useAnalytics = document.location.hostname === 'whitney.org';
// Transition duration timings (should match css variables)
window.transitionDuration = 100;
window.transitionDurationSlow = 200;
// Variable for tracking previous window width
window.cacheWidth = window.innerWidth;
// These require the window resize listener in application.js to update if viewport size changes
// Helpful global var for knowing if the main nav has collapsed (should match css media queries)
window.isNavSmall = window.innerWidth < 800;
window.isSmall = window.innerWidth < 650;
window.isMedium = window.innerWidth >= 650 && window.innerWidth < 1000;

